import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { SelectedItem } from "../shared/selected-item";

export const SortableItem = ({ id, item, removeValue, disabled }) => {
    const { listeners, setNodeRef, transform, transition } = useSortable({ id });
    const style = {
        transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
        transition,
        cursor: "grab",
    };

    return (
        <div
            ref={setNodeRef}
            style={style}
            {...listeners}
        >
            <SelectedItem
                value={item.value}
                text={item.text}
                removeValue={() => removeValue(item)}
                disabled={disabled}
            />
        </div>
    );
};
